const WORKFLOW_CONFIRMATION_METHOD = [
    { value: 0, text: 'None' },
    { value: 1, text: 'Call' },
    { value: 2, text: 'Text' }
];

type WORKFLOW_CONFIRMATION_METHOD = typeof WORKFLOW_CONFIRMATION_METHOD;

export default WORKFLOW_CONFIRMATION_METHOD;